import { render } from "./PRCarouselV3.vue?vue&type=template&id=f20dcb4a&ts=true&lang=pug"
import script from "./PRCarouselV3.vue?vue&type=script&lang=ts"
export * from "./PRCarouselV3.vue?vue&type=script&lang=ts"

import "./PRCarouselV3.vue?vue&type=style&index=0&id=f20dcb4a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__